import * as NumberFormat from 'utils/numberFormat';
import * as Persistent from 'utils/persistent';
import * as SmartPhoneNumber from 'utils/smartPhoneNumber';
import * as LocalizationHelpers from 'utils/localizationHelpers';
import * as Text from 'utils/text';
import * as InputsForm from 'utils/inputsForm';
import * as UtilsWindow from 'utils/window';
import * as Utils from 'utils/global';
import * as Currency from 'utils/currency';

window.Utils              = Utils;
window.UtilsWindow        = UtilsWindow;
window.Persistent         = Persistent;
window.Text               = Text;
window.LocalizationHelpers= LocalizationHelpers;
window.InputsForm         = InputsForm;
window.NumberFormat       = NumberFormat;
window.SmartPhoneNumber   = SmartPhoneNumber;
window.Currency           = Currency;

String.prototype.contains = function(it) {
	return this.indexOf(it) != -1;
};

function isNormalInteger(str) {
    var n = ~~Number(str);
    return String(n) === str && n > 0;
}

if (typeof String.prototype.endsWith !== 'function') {
	String.prototype.endsWith = function (suffix) {
		return this.indexOf(suffix, this.length - suffix.length) !== -1;
	};
}

// Add filter :truncated, for detec if the text is too long and will overflow from its container
$.expr[':'].truncated = function(obj) {
	var $this = $(obj);
	var $c = $this
		.clone()
		.css({display: 'inline', width: 'auto', visibility: 'hidden'})
		.appendTo('body');

	var c_width = $c.width();
	$c.remove();

	if (c_width > $this.width()) {
		return true;

	}
	return false;
};
